<div class="container d-flex align-items-center h-100 justify-content-center">
  <div class="error-page">
    <p>
      <img src="assets/images/404.svg#notFound" alt="404" class="img-fluid" />
    </p>

    <div class="col-12 error-msg">
      <h1>Something is wrong!</h1>
      <p>The page you are looking for cannot be found or it might never existed.</p>
      <p>
        <a href="javascript:void(0);"  [routerLink]="['/']" (click)="onClick()" class="btn btn-primary">Go back to homepage</a>
      </p>
    </div>
  </div>
</div>
